import { createPageApp } from '@/lib/createPageApp'
import ViewProductPage from './ViewProductPage.vue'

createPageApp(ViewProductPage).mount()
